//  Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      direction="row"
      component="footer"
      py={2}
      pb={0}
    >
      {/* <VuiBox item xs={12} sx={{ textAlign: "center" }}>
        <VuiTypography
          variant="button"
          sx={{ textAlign: "center", fontWeight: "400 !important" }}
          color="white"
        >
          @ 2025, Made with ❤️&nbsp;&nbsp;&nbsp; by
          <VuiTypography
            ml="2px"
            mr="2px"
            component="a"
            variant="button"
            href="https://sameerdev.in/"
            target="_blank"
            sx={{ textAlign: "center", fontWeight: "500 !important" }}
            color="white"
          >
            Sameer Singh
          </VuiTypography>
        </VuiTypography>
      </VuiBox> */}
    </VuiBox>
  );
}

export default Footer;
